<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Đội xe ngoài
            </h2>
            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)
const headers = [
  {
    field: 'name',
    headerName: $t('labels.partner')
  },
  {
    field: 'totalJourney',
    headerName: 'Số chặng hoàn thành',
    valueGetter: (params: any) => {
      const totalJourney = $formatters.formatNumber(params.data.totalJourney || 0)
      return totalJourney
    }
  },
  {
    field: 'totalKm',
    headerName: $t('labels.totalKmRun'),
    valueGetter: (params: any) => {
      const { totalKm } = params.data
      return `${$formatters.formatNumber(totalKm || 0)} km`
    }
  },
  {
    field: 'buyingPrice',
    headerName: 'Chi phí vận chuyển',
    valueGetter: (params: any) => {
      const { buyingPrice } = params.data
      return $formatters.formatNumber(buyingPrice || 0)
    }
  },
  {
    field: 'onTimeRate',
    headerName: $t('labels.onTimeRate'),
    valueGetter: (params: any) => {
      const totalJourney = $formatters.formatNumber(params.data.totalJourney || 0)
      const totalOnTime = $formatters.formatNumber(params.data.totalOnTime || 0)

      if (!totalJourney) {
        return ''
      }

      return `${totalOnTime}/${totalJourney}`
    }
  },
  {
    field: 'rejectionRate',
    headerName: $t('labels.journeyRejectionRate'),
    valueGetter: (params: any) => {
      const totalJourney = $formatters.formatNumber(params.data.totalJourney || 0)
      const totalReject = $formatters.formatNumber(params.data.totalReject || 0)

      if (!totalReject) {
        return ''
      }

      return `${totalReject}/${totalJourney}`
    }
  },
  {
    field: 'cancellationByPartnerRate',
    headerName: $t('labels.rateChangeCancelRequestByParner'),
    valueGetter: (params: any) => {
      const totalJourney = $formatters.formatNumber(params.data.totalJourney || 0)
      const totalCancelByPartner = $formatters.formatNumber(params.data.totalCancelByPartner || 0)

      if (!totalCancelByPartner) {
        return ''
      }

      return `${totalCancelByPartner}/${totalJourney}`
    }
  },
  {
    field: 'cancellationByOtherRate',
    headerName: $t('labels.rateChangeCancelRequestByOther'),
    valueGetter: (params: any) => {
      const totalJourney = $formatters.formatNumber(params.data.totalJourney || 0)
      const totalCancelByOther = $formatters.formatNumber(params.data.totalCancelByOther || 0)

      if (!totalCancelByOther) {
        return ''
      }

      return `${totalCancelByOther}/${totalJourney}`
    }
  },
  {
    field: 'cancellationByCustomerRate',
    headerName: $t('labels.rateChangeCancelRequestByCustomer'),
    valueGetter: (params: any) => {
      const totalJourney = $formatters.formatNumber(params.data.totalJourney || 0)
      const totalCancelByCusomter = $formatters.formatNumber(params.data.totalCancelByCusomter || 0)

      if (!totalCancelByCusomter) {
        return ''
      }

      return `${totalCancelByCusomter}/${totalJourney}`
    }
  },
  {
    field: 'profitRate',
    headerName: 'Tỷ suất lợi nhuận',
    valueGetter: (params: any) => {
      const { profitRate } = params.data
      return `${profitRate} %`
    }
  }
]

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getPartner, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
